module.exports = __webpack_public_path__ + "static/img/a1.7871733.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/safe/a1.png
// module id = fKmz
// module chunks = 1